$(() => {
  $('.slider-home').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 991,
      settings: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }]
  });
});
